<template>
  <v-card flat color="transparent">
    <v-container class="py-0">
      <v-row>
        <v-col cols="auto" class="py-0">
          <v-card-title>
            Start from an existing template
          </v-card-title>
          <v-card-subtitle>
            Get inspiration and a big head start when you customize a pre-built
            template
          </v-card-subtitle>
        </v-col>
        <v-spacer></v-spacer>
        <v-select
          v-model="filterId"
          :items="filterItems"
          outlined
          label="Filter surveys"
          clearable
          hide-details
        >
        </v-select>
      </v-row>
    </v-container>
    <v-card-text class="py-0">
      <v-container class="py-0">
        <v-row>
          <template v-if="loading">
            <v-col cols="12" sm="6" md="4" v-for="i in 10" :key="i">
              <v-skeleton-loader type="image,actions"></v-skeleton-loader>
            </v-col>
          </template>
          <template v-else-if="filtered_survey_templates.length">
            <v-col
              cols="12"
              sm="6"
              lg="4"
              v-for="(surveyTemplate, i) in filtered_survey_templates"
              :key="i"
            >
              <v-card @click="$emit('select', surveyTemplate.id)">
                <v-img :src="surveyTemplate.imageUrl" height="130px"></v-img>
                <v-card-subtitle class="pb-1">
                  <v-icon>query_builder</v-icon>
                  {{ surveyTemplate.questionCount }} Questions
                </v-card-subtitle>
                <v-responsive height="80">
                  <v-card-title class="pt-1">
                    {{ surveyTemplate.title }}
                  </v-card-title>
                </v-responsive>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-chip
                    outlined
                    color="primary"
                    class="mr-1"
                    v-if="corevalue(surveyTemplate)"
                  >
                    {{ corevalue(surveyTemplate) }}
                  </v-chip>
                </v-card-actions>
              </v-card>
            </v-col>
          </template>
          <v-col cols="12" v-else>
            <h3>No survey templates available</h3>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SurveyTemplateList",
  props: { initialFilter: { type: String } },
  data: () => ({
    search: "",
    filterId: "",
    loading: true
  }),
  computed: {
    corevalue() {
      return template => {
        if (template.mission) {
          return this.t("mission.title");
        }
        return template.coreValueName;
      };
    },
    filtered_survey_templates() {
      if (!this.filterId) {
        return this.survey_templates;
      } else if (this.filterId == "mission") {
        return this.survey_templates.filter(x => x.mission);
      }
      return this.survey_templates.filter(x => x.coreValueId == this.filterId);
    },
    filterItems() {
      let list = [{ value: "mission", text: this.t("mission.title") }];

      this.core_values.forEach(x => {
        list.push({ value: x.id, text: x.name });
      });

      return list;
    },
    ...mapGetters({
      survey_templates: "survey/survey_templates",
      core_values: "company/coreValues"
    })
  },
  created() {
    this.filterId = this.initialFilter;
    this.$store
      .dispatch("survey/getSurveyTemplates")
      .catch(error => {
        this.logError(error);
        this.$root.$alert(
          "Error Occurred",
          "An error occured while loading survey templates."
        );
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {}
};
</script>
